import React, { useState, useEffect } from 'react';
import { useQueryClient, useQuery } from '@tanstack/react-query';

import { message, Spin, Alert } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import { apiGet, apiPost, apiPutRequest } from 'helpers/ApiHelper';
import ListParking from './ListParking';
import ParkingForm from './ParkingForm';

const modes = {
  LOADING: 'loading',
  NOT_AVAILABLE: 'not_available',
  LIST: 'list',
  ADD: 'add',
};

const ParkingBlockForm = ({ formMinInstances, formMaxInstances, application, cotenant }) => {
  const queryClient = useQueryClient();
  const [mode, setMode] = useState(modes.LOADING);
  // TODO: fuzzy search for any looking like parking, need to change to types after.
  const [selectedAncillaryItems, setSelectedAncillaryItems] = useState(
    application?.lease?.lease_charges?.filter((charge) =>
      charge.item_type_code.match(/parking/i)
    ) || []
  );

  const { data: ancillaryItems } = useQuery({
    queryKey: ['ancillary_items', cotenant.id],
    retry: false,
    queryFn: () =>
      apiGet(
        `/leads/application_portal/cotenants/${cotenant.id}/ancillary_items/available_ancillary_items`,
        {
          item_type: 'parking',
        }
      ).then((res) => res.ancillary_items),
    onSuccess: (data) => {
      if (data.length > 0) {
        setMode(modes.LIST);
        return;
      }
      setMode(modes.NOT_AVAILABLE);
    },
    onError: () => setMode(modes.NOT_AVAILABLE),
  });

  const handleRemoveItem = (record) => {
    setMode(modes.LOADING);

    apiPutRequest(
      `/leads/application_portal/cotenants/${cotenant.id}/ancillary_items/remove_item`,
      record
    )
      .done((res) => {
        setSelectedAncillaryItems(
          selectedAncillaryItems.filter(
            (item) => item.ancillary_item_id !== record.ancillary_item_id
          )
        );
        queryClient.invalidateQueries('cotenant', cotenant.id);
        setMode(modes.LIST);
      })
      .catch((e) => {
        setMode(modes.LIST);
      });
  };

  const handleAddItem = (values) => {
    setMode(modes.LOADING);
    apiPost(`/leads/application_portal/cotenants/${cotenant.id}/ancillary_items/add_item`, values)
      .done((res) => {
        setSelectedAncillaryItems([...selectedAncillaryItems, values]);
        queryClient.invalidateQueries('cotenant', cotenant.id);
        setMode(modes.LIST);
      })
      .catch((e) => {
        message.error(getTranslatedString('unknownError'));
        setMode(modes.LIST);
      });
  };

  if (mode === modes.LOADING) {
    return <Spin />;
  } else if (mode === modes.LIST) {
    return (
      <ListParking
        setAddParking={() => setMode(modes.ADD)}
        selectedAncillaryItems={selectedAncillaryItems}
        removeAncillaryItem={handleRemoveItem}
        formMaxInstances={formMaxInstances}
      />
    );
  } else if (mode === modes.ADD) {
    return (
      <ParkingForm
        ancillaryItems={ancillaryItems}
        onClose={() => setMode(modes.LIST)}
        onAdd={handleAddItem}
      />
    );
  } else if (mode === modes.NOT_AVAILABLE) {
    return (
      <Alert
        message={getTranslatedString('tenantPortal.application.parking.noProperties')}
        type="error"
        showIcon
      />
    );
  }
};

export default ParkingBlockForm;
